import { Star } from 'lucide-react'
import { reviews } from '../../data/homepage'
import { ButtonLink } from '../ui/button'

export interface TestimonialsSectionProps {}

export function TestimonialsSection(_: Readonly<TestimonialsSectionProps>) {
  return (
    <>
      <section className="testimonials-section" aria-labelledby="reviews-heading">
        <div className="section-container">
          <div className="reputation-heading">
            <div>
              <h2 id="reviews-heading">Studio Reputation</h2>
              <div>
                {[0, 1, 2, 3, 4].map((item) => (
                  <Star size={18} fill="currentColor" key={item} />
                ))}
                <span>Verified Google Reviews</span>
              </div>
            </div>
          </div>

          <div className="reviews-grid">
            <article className="featured-review">
              <div className="stars">
                {[0, 1, 2, 3, 4].map((item) => (
                  <Star size={16} fill="currentColor" key={item} />
                ))}
              </div>
              <p>"{reviews[0].quote}"</p>
              <div>
                <span>JD</span>
                <div>
                  <strong>{reviews[0].author}</strong>
                  <small>{reviews[0].detail}</small>
                </div>
              </div>
            </article>

            <div className="side-reviews">
              {reviews.slice(1).map((review) => (
                <article className="small-review" key={review.author}>
                  <p>"{review.quote}"</p>
                  <strong>{review.author}</strong>
                </article>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="conversion-banner final-home-cta" id="home-cta" aria-labelledby="final-home-cta-heading">
        <div className="section-container conversion-grid">
          <div>
            <h2 id="final-home-cta-heading">Not sure what your vehicle needs?</h2>
            <p>Tell us about your vehicle and what you want to achieve. We will recommend the right detailing or protection option.</p>
          </div>
          <div>
            <ButtonLink href="/contact" variant="inverse">Request a Free Quote</ButtonLink>
            <ButtonLink href="/book" variant="ghost">Book Now</ButtonLink>
          </div>
        </div>
      </section>
    </>
  )
}
